import {
  Box,
  Flex,
  Spinner,
  Text,
  Center,
  Button,
  useToast,
  Textarea,
  Divider,
} from '@chakra-ui/react';
import { InfoOutlineIcon } from '@chakra-ui/icons';
import { MdArrowForward } from 'react-icons/md';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { OrderStatusOptions, OrderTypeOptions } from 'config/constant';
import Card from 'components/card/Card';

const TaskCashDeposit = (props) => {
  const details = props.details;

  const taskTypeButton = [
    {
      value: 'OPEN_SAVING_PLAN',
      taskButton: (
        <Button
          variant='light'
          onClick={() => {
            GoToSavingPlan(details?.info?.customer_saving_plan_id);
          }}>
          <Text
            fontWeight='bold'
            mr={2}>
            View Connected Saving Plan
          </Text>
          <MdArrowForward />
        </Button>
      ),
    },
    {
      value: 'INSTALLMENT_SAVING_PLAN',
      taskButton: (
        <Button
          variant='light'
          onClick={() => {
            GoToSavingPlan(details?.info?.customer_saving_plan_id);
          }}>
          <Text
            fontWeight='bold'
            mr={2}>
            View Connected Saving Plan
          </Text>
          <MdArrowForward />
        </Button>
      ),
    },
  ];

  const GoToOrder = (id) => {
    // console.log(id)
    const url = `/admin/order/${id}`;
    window.open(url, '_blank');
  };

  const GoToSavingPlan = (id) => {
    // console.log(id)
    const url = `/admin/myplan/${id}`;
    window.open(url, '_blank');
  };

  const GoToCustomerUser = (id) => {
    // console.log(id)
    const url = `/admin/customeruser/${id}`;
    window.open(url, '_blank');
  };

  const GoToAdminUser = (id) => {
    // console.log(id)
    const url = `/admin/adminuser/${id}`;
    window.open(url, '_blank');
  };

  const GoToStore = (id) => {
    const url = `/admin/store/${id}`;
    window.open(url, '_blank');
  };

  return (
    <>
      <Flex
        mt={2}
        direction='column'
        gap={3}
        width='100%'>
        <Text
          fontSize='2xl'
          fontWeight='500'>
          Deposit Details
        </Text>
        <Card bgColor='gray.200'>
          <Flex
            direction={{ base: 'column', '2xl': 'row' }}
            gap={4}>
            <Flex
              h='100%'
              width='100%'
              direction='column'
              gap={4}
              bgColor='gray.200'>
              <Card
                h='100%'
                gap={4}
                bgColor='gray.100'>
                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>Order No.</Text>
                  <Text>{details?.info?.order_number}</Text>
                </Flex>

                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>Receipt Number</Text>
                  <Text>{details?.info?.recipt_number}</Text>
                </Flex>

                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>Order Status</Text>
                  <Text
                    fontSize='sm'
                    fontWeight='700'
                    color={
                      details?.info?.order_status === 'COMPLETED'
                        ? 'green'
                        : details?.info?.order_status === 'FAILED'
                        ? 'red'
                        : ''
                    }>
                    {OrderStatusOptions.find(
                      (option) => option.value === details?.info?.order_status
                    )?.label.toUpperCase()}
                  </Text>
                </Flex>

                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>Order Type</Text>
                  <Text fontWeight='700'>
                    {
                      OrderTypeOptions.find(
                        (option) => option.value === details?.info?.order_type
                      )?.label
                    }
                  </Text>
                </Flex>

                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>Amount Deposited</Text>
                  <Text fontWeight='700'>
                    Rs {details?.info?.depost_amount}
                  </Text>
                </Flex>

                <Button
                  variant='light'
                  onClick={() => {
                    GoToOrder(details?.info?.order_id);
                  }}>
                  <Text
                    fontWeight='bold'
                    mr={2}>
                    View Order{/*  No. {details?.info?.order_number} */}
                  </Text>
                  <MdArrowForward />
                </Button>
              </Card>
            </Flex>
            <Divider
              display={{ base: 'none', '2xl': 'block' }}
              borderColor='gray.500'
              orientation='vertical'
            />
            <Divider
              display={{ base: 'block', '2xl': 'none' }}
              borderColor='gray.500'
              orientation='horizontal'
            />
            <Flex
              width='100%'
              direction='column'
              gap={4}
              bgColor='gray.200'>
              <Card
                gap={4}
                bgColor='gray.100'>
                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>Order By</Text>
                  <Text>{details?.info?.user?.name}</Text>
                </Flex>

                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>E-mail Add.</Text>
                  <Text>{details?.info?.user?.email}</Text>
                </Flex>
                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>Phone No.</Text>
                  <Text>{details?.info?.user?.phone_number}</Text>
                </Flex>

                <Button
                  variant='light'
                  onClick={
                    // details?.info?.user_type === 'CUSTOMER' ?
                    () => {
                      GoToCustomerUser(details?.info?.user_id);
                    }
                    //   : () => {
                    //       GoToAdminUser(details?.info?.details?.user_id);
                    //     }
                  }>
                  <Text
                    fontWeight='bold'
                    mr={2}>
                    View {details?.info?.user?.name}
                  </Text>
                  <MdArrowForward />
                </Button>
                {
                  taskTypeButton.find(
                    (task) => task.value === details?.info?.order_type
                  )?.taskButton
                }
              </Card>
            </Flex>
            <Card bgColor='gray.100'>
              <Flex
                direction='column'
                gap={4}>
                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>Deposit Store</Text>
                  <Text fontWeight='bold'>
                    {details?.info?.deposit_store?.name} ({details?.info?.deposit_store?.store_code})
                  </Text>
                </Flex>

                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>E-mail Add.</Text>
                  <Text>{details?.info?.deposit_store?.email}</Text>
                </Flex>

                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>Phone Number</Text>
                  <Text>{details?.info?.deposit_store?.phone_number}</Text>
                </Flex>

                <Flex
                  justifyContent='space-between'
                  gap={2}>
                  <Text fontWeight='medium'>Address</Text>
                  <Text
                    textAlign='right'
                    maxW={{ base: 'none', '2xl': '200px' }}>
                    {details?.info?.deposit_store?.address_line1},{' '}
                    {details?.info?.deposit_store?.city},{' '}
                    {details?.info?.deposit_store?.state},{' '}
                    {details?.info?.deposit_store?.pincode}
                  </Text>
                </Flex>

                <Button
                  variant='light'
                  onClick={() => {
                    GoToStore(details?.info?.store_id);
                  }}>
                  <Text
                    fontWeight='bold'
                    mr={2}>
                    View {details?.info?.deposit_store?.name}
                  </Text>
                  <MdArrowForward />
                </Button>
              </Flex>
            </Card>
          </Flex>
        </Card>
      </Flex>
    </>
  );
};

export default TaskCashDeposit;
